module.exports = __webpack_public_path__ + "img/phone-frame.a6767775.png";